import type { UseQueryResult, UseMutationResult } from 'react-query';
import { useQuery, useMutation } from 'react-query';
import {
  getRegistrationCampaign,
  applyCampaignToAccount,
} from '@hotjar/webapp/domains/campaigns/api';
import type { ApplyCampainResponse } from '@hotjar/webapp/domains/campaigns/api';
import type { RegistrationCampaign } from '@hotjar/webapp/domains/campaigns/model';

export const REGISTRATION_CAMPAIGN = 'registrationCampaign';

export const ASSIGN_CAMPAIGN = 'assignCampaign';

export const useRegistrationCampaign = (
  campaignId?: string,
): UseQueryResult<RegistrationCampaign, Error> => {
  return useQuery(REGISTRATION_CAMPAIGN, () => getRegistrationCampaign(campaignId as string), {
    staleTime: 60 * 60 * 1000,
    cacheTime: 60 * 60 * 1000,
    refetchOnWindowFocus: false,
    enabled: !!campaignId,
  });
};

export function useAssignCampaignToAccount(): UseMutationResult<
  ApplyCampainResponse,
  void,
  Parameters<typeof applyCampaignToAccount>[0]
> {
  return useMutation(
    async function mutationFunction({
      campaignId,
      accountId,
    }: Parameters<typeof applyCampaignToAccount>[0]) {
      return applyCampaignToAccount({ campaignId, accountId });
    },
    { mutationKey: ASSIGN_CAMPAIGN },
  );
}
